import React from 'react';
import { RepairOrder } from 'src/models';
import css from '../../ServiceDocs.module.scss';
import { Checkbox } from '@framework-controls/core';
import { IconVideo } from 'src/content/icons';

export interface IProps {
    selectedRO: RepairOrder;
    checked: boolean;
    index: number;
    url: string;
    urlType: string;
    date: string;
    time: string;
    previewFlag: string;
    onToggle: (index: number, checked: boolean, e:any) => void;
    setFullImgFlag: (flag: boolean) => void;
    setCurrentFullImage: (index: number) => void;
    logDocsHistory: (keyRO: string, action: string, docType: string, details: string, idmUrl: string) => void;
    addCUC: (cucNum: number) => void;
}

const ServiceDocsMediaItem = (props: IProps) => {
    const itemDate = props.date;
    const itemTime = props.time;

    return (
        <div className={css.imgVidBlock}>
            <div>
                {props.urlType === 'I'?
                    <img
                        src={props.url}
                        alt={''}
                        className={css.serviceImg}
                        onClick={() => {
                            props.setFullImgFlag(true);
                            props.setCurrentFullImage(props.index);
                            if (!props.previewFlag) {
                                props.logDocsHistory(props.selectedRO.RONum, 'DV', 'IV', '', props.url);
                                props.addCUC(869);
                            }
                        }}
                    >
                    </img>:
                    <div
                        className={css.videoThumbnail}
                        onClick={() => {
                            props.setFullImgFlag(true);
                            props.setCurrentFullImage(props.index);
                            if (!props.previewFlag) {
                                props.logDocsHistory(props.selectedRO.RONum, 'DV', 'IV', '', props.url);
                            }
                        }}>
                        <div className={css.videoThumbIcon}><IconVideo /></div>
                    </div>
                }
                <div className={props.urlType === 'I' ? css.imageChkBox: css.videoChkBox}>
                    <Checkbox
                        id={'imageCheck' + props.index}
                        variant={'primaryChk'}
                        checked={props.checked}
                        onChange={(e:any) => props.onToggle(props.index, !props.checked, e)} />
                </div>
            </div>
            {/* Time stamp image was colded HH:MMXX - MM/DD/YY */}
            <div className={css.serviceImgTimeStamp}>
                {itemTime+' - '+itemDate}
            </div>
        </div>
    );
};

export default ServiceDocsMediaItem;